module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_Background.97bffe28.png";